export default __webpack_public_path__ + "static/media/contactus-bg.a7034037.svg";